/**
 * @name ChangePasswordPage.jsx
 * @description 비밀번호 강제 변경 페이지
 * - 임시 비밀번호로 로그인한 사용자가 반드시 거쳐야 하는 화면
 * - 새 비밀번호 입력 후 변경 완료 시 메인으로 이동
 */
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { post } from '@utils/axios_api';
import { AuthContext } from '@context';
import { toast } from 'react-toastify';
import './Login.css';

const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const { auth, logout, clearForceChangePw } = useContext(AuthContext);

  const [form, setForm] = useState({ password: '', confirmPassword: '' });
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrorMsg('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.password || !form.confirmPassword) {
      setErrorMsg('새 비밀번호를 모두 입력해 주세요.');
      return;
    }

    if (form.password !== form.confirmPassword) {
      setErrorMsg('비밀번호가 일치하지 않습니다.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await post('/auth/change-password', { password: form.password }, {
        headers: { 'Content-Type': 'application/json' },
      });

      clearForceChangePw();
      toast.success(response.message || '비밀번호가 변경되었습니다.');
      setTimeout(() => navigate('/main'), 1500);
    } catch (err) {
      // axios interceptor가 status:false 응답을 이미 toast로 표시하고 throw함
      // → 여기선 별도 setErrorMsg 없이 interceptor에 위임 (이중 표시 방지)
      console.error('비밀번호 변경 오류:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main-container">
      <div className="login-container">
        {/* 로고 */}
        <div className="logo">
          <img src="/img/logo.png" alt="회사 로고" />
        </div>

        <div className="login-form">
          {/* 안내 배너 */}
          <div style={{
            background: '#fff3e0',
            border: '1px solid #FF9800',
            borderRadius: '6px',
            padding: '12px 16px',
            marginBottom: '20px',
            fontSize: '0.9rem',
            color: '#e65100'
          }}>
            ⚠️ 임시 비밀번호로 로그인하셨습니다.<br />
            보안을 위해 새 비밀번호로 변경해 주세요.
          </div>

          <h1>비밀번호 변경</h1>
          <p style={{ color: '#666', marginBottom: '20px', fontSize: '0.9rem' }}>
            <strong>{auth?.userId}</strong> 계정의 비밀번호를 변경합니다.
          </p>

          {/* 에러 메시지 */}
          {errorMsg && (
            <p className="error-message red" style={{ marginBottom: '12px' }}>{errorMsg}</p>
          )}

          <form onSubmit={handleSubmit}>
            <div className="login_input_wrap">
              <input
                type="password"
                name="password"
                placeholder="새 비밀번호를 입력해 주세요."
                value={form.password}
                onChange={handleChange}
                maxLength="20"
              />
              <input
                type="password"
                name="confirmPassword"
                placeholder="새 비밀번호를 다시 입력해 주세요."
                value={form.confirmPassword}
                onChange={handleChange}
                maxLength="20"
              />
            </div>
            <button
              type="submit"
              className="login-button"
              disabled={isLoading}
              style={{ marginTop: '16px' }}
            >
              {isLoading ? '변경 중...' : '비밀번호 변경'}
            </button>
          </form>

          {/* 로그아웃 링크 */}
          <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '0.9rem' }}>
            <button
              type="button"
              onClick={() => logout()}
              style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', textDecoration: 'underline' }}
            >
              로그아웃
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ChangePasswordPage };
